import SectionHeader from "../../components/SectionHeader/SectionHeader";
import EventsBlock from "./components/EventsBlock/EventsBlock";
import GaleryBlock from "./components/GaleryBlock/GaleryBlock";
import InfoBlock from "./components/InfoBlock/InfoBlock";
import TargetsBlock from "./components/TargetsBlock/TargetsBlock";


export default function Home() {
    return (
        <>
            <InfoBlock />
            <SectionHeader>Wydarzenia</SectionHeader>
            <EventsBlock />
            <SectionHeader>Cele Fundacji</SectionHeader>
            <TargetsBlock />
            <SectionHeader>Galeria</SectionHeader>
            <GaleryBlock />
        </>
    )
}